var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg404Error(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 217.7,
    y1: 424.895,
    x2: 217.7,
    y2: 356.225
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 294.3,
    y1: 424.895,
    x2: 294.3,
    y2: 356.225
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M449.8,356.225h38.7c8.837,0,16-7.163,16-16V66.105c0-8.837-7.163-16-16-16h-465c-8.837,0-16,7.163-16,16v274.12 c0,8.837,7.163,16,16,16h391.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M342.851,461.895H169.149c-5.523,0-10-4.477-10-10v0c0-14.912,12.088-27,27-27h139.702c14.912,0,27,12.088,27,27v0 C352.851,457.418,348.374,461.895,342.851,461.895z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 7.5,
    y1: 308.884,
    x2: 504.5,
    y2: 308.884
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M253.151,241.309c-14.875-0.442-26.521-13.037-26.521-27.919v-66.515c0-14.882,11.646-27.477,26.521-27.919 c15.457-0.459,28.177,11.982,28.177,27.337v67.679C281.329,229.328,268.608,241.768,253.151,241.309z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M199.459,128.693c7.416-22.936,28.93-39.582,54.274-39.689c31.647-0.134,57.536,26.628,57.536,58.275v65.825 c0,31.439-24.965,57.673-56.401,58.153c-31.996,0.488-58.179-25.397-58.179-57.283v-50.28"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M167.269,204.179c-0.772-7.657-7.071-13.298-14.238-13.298h0c-1.652,0-2.989-1.443-2.98-3.219 c0.184-34.573,0.274-70.971-0.12-76.063c-0.857-11.047-6.993-20.043-15.632-22.919c-8.553-2.846-17.687,0.768-24.436,9.666 c-4.773,6.293-20.903,35.985-47.944,88.252c-3.678,7.11-3.635,15.525,0.101,22.574c3.886,7.332,11.327,11.649,19.178,11.649 h37.786c1.655,0,2.993,1.45,2.981,3.229c-0.038,5.432,0,32.243,0,32.243c0,8.268,6.237,14.971,13.93,14.971h0 c7.693,0,13.93-6.703,13.93-14.971v-32.287c0.012-1.759,1.343-3.185,2.98-3.185h0.619 C161.63,220.82,168.178,213.196,167.269,204.179z M120.193,190.881H94.981c-1.52,0-2.477-1.76-1.735-3.186 c10.957-21.056,19.31-36.79,25.403-48.016c1.024-1.886,3.708-1.1,3.706,1.083c-0.011,13.361-0.078,30.36-0.172,47.99 C122.176,189.929,121.287,190.881,120.193,190.881z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M452.726,204.179c-0.772-7.657-7.071-13.298-14.238-13.298h0c-1.652,0-2.989-1.443-2.98-3.219 c0.184-34.573,0.274-70.971-0.12-76.063c-0.857-11.047-6.993-20.043-15.632-22.919c-8.553-2.846-17.687,0.768-24.436,9.666 c-4.773,6.293-20.903,35.985-47.944,88.252c-3.678,7.11-3.635,15.525,0.101,22.574c3.886,7.332,11.327,11.649,19.178,11.649 h37.786c1.655,0,2.993,1.45,2.981,3.229c-0.038,5.432,0,32.243,0,32.243c0,8.268,6.237,14.971,13.93,14.971h0 c7.693,0,13.93-6.703,13.93-14.971v-32.287c0.012-1.759,1.343-3.185,2.98-3.185h0.619 C447.087,220.82,453.635,213.196,452.726,204.179z M405.65,190.881h-25.212c-1.52,0-2.477-1.76-1.735-3.186 c10.957-21.056,19.31-36.79,25.402-48.016c1.024-1.886,3.708-1.1,3.706,1.083c-0.011,13.361-0.078,30.36-0.172,47.99 C407.633,189.929,406.744,190.881,405.65,190.881z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Error);
export default __webpack_public_path__ + "static/media/404_error.be1f20dd.svg";
export { ForwardRef as ReactComponent };